import { IBooking, IServiceItem, IServiceListView, ISimpleSelectTimeDropdown } from 'shared-types/SharedTypes';
import { bookingStatusType } from 'shared-types/bookingStatusTypes';
import {IFloorplanBookingsByTable} from "floorplan-v2/app/reducers/bookings/types";


export class FloorplanBookingFilterService {

  getBookingsByTable(bookings: IBooking[]): {
    [key: string]: IFloorplanBookingsByTable;
  } {

    const bookingsByTable: {
      [key: string]: IFloorplanBookingsByTable;
    } = {};

    let hasEntries = false;
    bookings.forEach(b1 => {
      b1.tables.forEach(t => {
        const entry = bookingsByTable[t._id];
        if (entry) {
          if (!entry.bookings.some(b2 => b2._id === b1._id)) {
            entry.bookings.push(b1);
          }
        } else {
          hasEntries = true;
          bookingsByTable[t._id] = {
            bookings: [b1],
            table: t
          }
        }
      });
    });

    return hasEntries ? bookingsByTable : {};
  }

  filterBookingsByStatus(bookings: IBooking[]) {
    return bookings.filter(booking => {
      return booking.status.statusType !== bookingStatusType.cancelled;
    });
  }


  getBookingsForSelectedTime(bookings: IBooking[], selectedTime:Date): IBooking[] {
    return bookings.filter(b => selectedTime < b.bookingEnd && selectedTime >= b.time);
  }

  getAvailableServices(serviceList: IServiceListView[], selectedService: IServiceListView): IServiceItem[] {
    // if service groups exists we take those instead
    const serviceGroup = selectedService?.services;
    if (serviceGroup && serviceGroup.length > 0) {
      return serviceGroup;
    } else {
      return serviceList.map(t => t.service as IServiceItem).filter(Boolean);
    }
  }


  getBookingsAtTime(bookings: IBooking[], time: Date): IBooking[] {
    return bookings.filter(booking => {
      const startTime = new Date(booking.time);
      const endTime = new Date(booking.bookingEnd);
      return time >=startTime && time < endTime;
    });
  }

  filterBookingsByIds(bookings: IBooking[], ids: string[]): IBooking[] {
    return bookings.filter(b => ids.includes(b._id))
  }

  /**
   * loops through bookings to find one with matching tableId, then returns if that table is shared
   */
  filterBookingsByTableId(targetBookings: IBooking[], tableId: string): IBooking[] {
    const bookingsOnTable: IBooking[] = targetBookings.filter((b) => {

      const isBookingWithTargetTable: boolean = b.tables.some(t => {
        if (t._id === (tableId)) {
          return true;
        }
        return false;
      });
      return isBookingWithTargetTable;
    });

    return bookingsOnTable;
  }


  /**
   * loops through bookings to find one with matching tableId, then returns if that table is shared
   */
  isSharedTableFromBookings(targetBookings: IBooking[], tableId: string): boolean {
    const isTableShared = targetBookings.some(b => {
      const table = b.tables.find(t => {
        if (t._id === tableId) {
          return true;
        }
        return false;
      });

      return table?.shared;
    });

    return isTableShared;
  }

  removeDuplicateTimes(allTimes: any[], type: string): any[] {
    return allTimes.reduce((unique: any[], o: any) => {
      if (!unique.some((obj: any) => obj[type].getTime() === o[type].getTime())) {
        unique.push(o);
      }
      return unique;
    }, []);
  }

  getTimeNowIndex = (times: ISimpleSelectTimeDropdown[]) => {
    return times.findIndex(t => t.name.includes('Now'));
  };

}
const instance = new FloorplanBookingFilterService();
export default instance as FloorplanBookingFilterService;
